import { FC } from 'react'

import List from '~/components/List'
import NameValue from '~/components/NameValue'
import Typography from '~/components/Typography'
import { toAmount, toLocaleNumber } from '~/lib/helpers'
import { useEarns } from '~/lib/useEarns'

import styles from './StakeInfo.pcss'
import { EarnStatus } from '~/contracts/useEarnContract'

const StakeInfo: FC = () => {
	const { contract } = useEarns()

	if (contract.status !== EarnStatus.SUCCESS) {
		return null
	}

	const depositAmount = toAmount(
		contract.token.decimals,
		contract.earn.userInfo.amount
	)
	const totalSupply = toAmount(
		contract.token.decimals,
		contract.token.balanceOfMaster
	)

	const apy = contract.apy() * 100
	const apyThreshold = 1000000

	return (
		<div className={styles.stakeInfo}>
			<List>
				<List.Item>
					<NameValue
						name={<Typography>APY</Typography>}
						value={
							<Typography color="green" align="right">
								{apy > apyThreshold
									? `>${toLocaleNumber(apyThreshold, 2)}`
									: toLocaleNumber(apy, 2)}
								%
							</Typography>
						}
					/>
				</List.Item>
				<List.Item>
					<NameValue
						name={<Typography>Your Deposits</Typography>}
						value={
							<Typography align="right">
								{depositAmount || '//'}
							</Typography>
						}
					/>
				</List.Item>
				<List.Item>
					<NameValue
						name={<Typography>Share of Pool</Typography>}
						value={
							<Typography align="right">
								{(Number(totalSupply) === 0
									? 0
									: (Number(depositAmount) /
											Number(totalSupply)) *
									  100
								).toFixed(2)}
								%
							</Typography>
						}
					/>
				</List.Item>
			</List>
		</div>
	)
}

export default StakeInfo
